import moment from 'moment-timezone';

export const obtenerZonaHoraria = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Lima';
  } catch {
    return 'America/Lima';
  }
};

export const parsearFechaUTC = (fechaStr) => {
  if (!fechaStr) return null;

   const isoMatch = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(fechaStr);
  if (isoMatch && !/Z$/.test(fechaStr)) {
    return moment.utc(fechaStr); // <- UTC explícito
  }

  return moment.utc(fechaStr);
};

export const formatearFechaHoraLocal = (fechaStr) => {
  const zona = obtenerZonaHoraria();
  const m = parsearFechaUTC(fechaStr);
  return m ? m.tz(zona).format('DD/MM/YYYY HH:mm') : '';
};

export const formatearSoloFechaLocal = (fechaStr) => {
  const zona = obtenerZonaHoraria();
  const m = parsearFechaUTC(fechaStr);
  return m ? m.tz(zona).format('DD/MM/YYYY') : '';
};

export const formatearSoloHoraLocal = (fechaStr) => {
  const zona = obtenerZonaHoraria();
  const mUtc = parsearFechaUTC(fechaStr);
  return mUtc ? mUtc.tz(zona).format('HH:mm') : '';
};
